import { createRequestHelper } from '../../common';
export const createDocumentRequest = createRequestHelper();
